import { useState } from 'react';
import { useParams } from 'react-router';
import { getCaseNode } from '@/api/nodes';
import { caseActions } from '@/stores/caseStore';
import { nodeActions } from '@/stores/nodeStore';
import BetterCostDataModal from './BetterCostDataModal';

const useBetterCostDataModal = ({ resetParams = false, recheckAnalysis = false, onComplete } = {}) => {
  const { pathwayId, caseId, nodeId } = useParams();
  const [suggestion, setSuggestion] = useState(null);

  const checkForSuggestion = async () => {
    if (!caseId || !nodeId) {
      setSuggestion(null);
      return false;
    }

    const [{ data }] = await Promise.all([
      getCaseNode(caseId, nodeId),
      ...(recheckAnalysis ? [caseActions.recheckBalanceAndAnalysis()] : []),
    ]);
    if (!data?.suggested_source) {
      setSuggestion(null);
      await nodeActions.init(pathwayId, caseId, nodeId);
      return false;
    }

    setSuggestion(data);
    return true;
  };

  const dismiss = () => setSuggestion(null);
  const complete = () => {
    dismiss();
    onComplete?.();
  };

  return {
    checkForSuggestion,
    betterCostDataModal: suggestion?.suggested_source ? (
      <BetterCostDataModal
        show
        currentSource={suggestion.params_source}
        suggestedSource={suggestion.suggested_source}
        dataviewerInfo={suggestion.dataviewer_info}
        resetParams={resetParams}
        onDismiss={dismiss}
        onComplete={complete}
      />
    ) : null,
  };
};

export default useBetterCostDataModal;
